import React from 'react';

export default React.createContext({
	rowIndex: null,
	columnIndex: null,
});
